import React, { FC, ImgHTMLAttributes, ReactNode, SyntheticEvent } from 'react';
import { useInView } from 'react-intersection-observer';

import { useProductCardContext } from '../../../context/ProductCardContext';
import { ProductImage, Root, Slot, SlotContainer } from './Image.styled';

export interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  /**
   * 상품 이미지 위에 overlap 형태로 보여질 컴포넌트 목록
   * 순서대로 top-left, top-right, bottom-right, bottom-left 에 위치
   */
  slots?: [ReactNode, ReactNode, ReactNode, ReactNode];
}

/**
 * 상품 이미지 컴포넌트
 */
export const Image: FC<React.PropsWithChildren<ImageProps>> = ({ style, className, loading = 'lazy', onLoad, slots = [], ...rest }) => {
  const { image_url, webp_image_url } = useProductCardContext();
  const { ref, inView } = useInView({ triggerOnce: true });

  const handleImageLoad = (e: SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.dataset.load = 'complete';
    onLoad?.(e);
  };

  return (
    <Root ref={ref} style={style} className={className}>
      {inView && (
        <ProductImage {...rest} src={webp_image_url ?? image_url ?? ''} loading={loading} onLoad={handleImageLoad} />
      )}
      <SlotContainer>
        {slots.map((node, index) => {
          const position = convertPosition(index);
          return (
            <Slot key={position} className={position}>
              {node}
            </Slot>
          );
        })}
      </SlotContainer>
    </Root>
  );
};

const convertPosition = (index: number) => {
  switch (index) {
    case 0:
      return 'top-left';
    case 1:
      return 'top-right';
    case 2:
      return 'bottom-right';
    case 3:
    default:
      return 'bottom-left';
  }
};
